import React from 'react';
import random from 'lodash.random';

import styles from './Watermark.module.scss';

function WaterMarkComponent({ text, containerRef }) {
  const watermarkRef = React.useRef();

  React.useEffect(() => {
    const interval = window.setInterval(() => {
      if (watermarkRef.current && new Date().getSeconds() % 5 === 0) {
        const { clientWidth: elemWidth, clientHeight: elemHeight } = watermarkRef.current;

        const containerWidth = containerRef.current.clientWidth - 50 - elemWidth;
        const containerHeight = containerRef.current.clientHeight - 50 - elemHeight;

        watermarkRef.current.style.opacity = 1;
        watermarkRef.current.style.top = `${random(25, containerHeight)}px`;
        watermarkRef.current.style.left = `${random(25, containerWidth)}px`;
      }
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <div ref={watermarkRef} data-watermark={text} className={styles.textContainer}>
      {text && <p className={styles.waterMarkText}>{text}</p>}
    </div>
  );
}

export default WaterMarkComponent;
